import { render, staticRenderFns } from "./aside.vue?vue&type=template&id=0c9e4bd3&scoped=true"
import script from "./aside.vue?vue&type=script&lang=js"
export * from "./aside.vue?vue&type=script&lang=js"
import style0 from "./aside.vue?vue&type=style&index=0&id=0c9e4bd3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c9e4bd3",
  null
  
)

export default component.exports